/**
 * @fileoverview POST handler for the "/apps/app_groups/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postAddNewAppCacheKeys } from "./constants";
import type { PostAppsAppGroupsAppGroupIdProps, AppsAppGroupsAppGroupIdResult } from "./types";

export const postAppsAppGroupsAppGroupId = reactQueryMutationAdapter(
  postAddNewAppCacheKeys,
  (props: PostAppsAppGroupsAppGroupIdProps): Promise<AppsAppGroupsAppGroupIdResult> => {
    return fetch(
      `/apps/app_groups/${props.appGroupId}`,
      "POST",
      {
        name: props.name,
        platforms: props.platforms,
      },
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
